import addCsrfFields from './_partials/_addCsrfFields'

document.addEventListener('DOMContentLoaded', addCsrfFields)
